// extracted by mini-css-extract-plugin
export default {"root":"TableToolbarNarrowGroups_root__pG+IY","menuLabel":"TableToolbarNarrowGroups_menuLabel__WNMTH","separator":"TableToolbarNarrowGroups_separator__Gf7eK"};